const CHANGE = '[workings]change';			// modify workings (with diff comparison)
const ADD = '[workings]add';						// add to end of workings (without diff)
const CHANGE_DRAWING = '[workings]change.drawing';	// replace the drawing scene (shapes + grid flag)
const SET_IMAGE_ID = '[workings]set.image.id';		// set the uploaded-image guid for the exported drawing
const CHANGE_CODE = '[workings]change.code';		// modify the code fragment

export {CHANGE, ADD, CHANGE_DRAWING, SET_IMAGE_ID, CHANGE_CODE}